module.exports = "/assets/data/eb2f9ef6e8dd2b68f93ab7835740ff5d-WC1X.data.json";